import JdFinanceBottomPopup from '../common/JdFinanceBottomPopup.vue';

function plugins(Vue) {
	Vue.component('JdFinanceBottom-Popup', JdFinanceBottomPopup);
}

export default plugins;



// WEBPACK FOOTER //
// ./src/components/common/JdFinanceBottomPopup.js